<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <app-credit-request-details-toolbar 
            [number]="number"
            [status]="creditRequest.status"
            [isSubmitting]="isSubmitting" 
            [isLoading]="isLoading" 
            [isExporting]="isExporting"
            (cancelClick)="cancel()" 
            (save)="onSaveClick($event)"
            (exportClick)="exportPdf()"
            [actions]="this.creditRequest.actions"
            [isReadOnly]="isReadOnly">
        </app-credit-request-details-toolbar>
    </div>
    <dx-load-panel container=".view-wrapper-scroll" [visible]="isLoading" [showPane]="false"
        [position]="{ of: 'credit-request-details' }">
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll" height="75vh">
        <dx-validation-group #validationGroup>
            @if (!isLoading) {
                <div class="form-container">
                    <div class="card border-0 shadow-sm pt-0 mb-4">
                        <div class="card-header d-flex justify-content-between align-items-center fs-5 fw-medium">
                            <span>Credit Request Details</span>
                            <span class="text-muted fs-5">
                                @if (number) {
                                    ID: {{ creditRequest.numberWithPrefix }}
                                }
                            </span>
                        </div>
                        <div class="card-body">
                            @if (number) {
                                <div class="row mb-3">
                                    <div class="col-6">
                                        <strong class="me-2">Status: </strong>
                                        <span class="badge" [ngClass]="getBadgeClass(creditRequest.status)">
                                            {{ creditRequest.status | creditRequestStatus }}
                                        </span>
                                    </div>
                                </div>
                            }
                            <div class="row g-3 mt-1">
                                <div class="col-md-12">
                                    <label class="form-label">Service Type: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="creditRequest.serviceTypeId" [dataSource]="serviceTypeDataSource"
                                            displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                            stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly"
                                            (onValueChanged)="onServiceTypeChanged()">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Service Type is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                            </div>
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <label class="form-label">Bill From: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="creditRequest.vendorId" [dataSource]="vendorDataSource"
                                            displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                            stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly" (onValueChanged)="updateVendorInfo(true)">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Bill From is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                    @if(vendor){
                                        <div class="mt-3">
                                            <ul class="list-unstyled">
                                                <li class="fw-bold">{{ vendor?.name }}</li>
                                                <li>{{ vendor.address }}</li>
                                                <li>{{ vendor.phone ?? '' | formatPhone }}</li>
                                                <li>{{ vendor.email }}</li>
                                                @if (vendor.contact) {
                                                    <li>
                                                        <span class="fw-bold">Contact: </span>
                                                        <a [routerLink]="`/employee/${vendor.contact.id}`" class="text-decoration-none">{{ vendor.contact.name }}</a>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">Bill To: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="creditRequest.billToClientId" [dataSource]="billToDataSource"
                                            displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                            stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly" (onValueChanged)="updateBillToInfo()">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Bill To is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                    @if (billTo) {
                                        <div class="mt-3">
                                            <ul class="list-unstyled">
                                                <li class="fw-bold">{{ billTo.name }}</li>
                                                <li>{{ billTo.address }}</li>
                                                <li>{{ billTo.city }}, {{ billTo.province }}, {{ billTo.postalCode }}</li>
                                                <li>{{ billTo.phoneNumber ?? '' | formatPhone }}</li>
                                            </ul>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr/>
                            <div class="row g-3 mt-1">
                                <div class="col-md-3">
                                    <label class="form-label">Invoice #: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="creditRequest.invoiceId" [dataSource]="invoiceOptionsDataSource"
                                            displayExpr="number" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                                            stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly"
                                            (onSelectionChanged)="onInvoiceChanged($event)">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Invoice is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">Currency: <span class="text-danger">*</span></label>
                                    <dx-select-box [(value)]="creditRequest.currency" [items]="currencyOptions"
                                        valueExpr="value" displayExpr="text" stylingMode="filled"
                                        placeholder="Select Currency" [readOnly]="isReadOnly"
                                        (onValueChanged)="updateCurrency()">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Currency is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">Issue Date: <span class="text-danger">*</span></label>
                                    <dx-date-box [(value)]="creditRequest.issueDate" [displayFormat]="dateFormat" stylingMode="filled" placeholder="Select Date" 
                                            [readOnly]="isReadOnly" (onValueChanged)="onDateChanged()">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Issue Date is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-date-box>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">Due Date: <span class="text-danger">*</span></label>
                                    <dx-date-box [(value)]="creditRequest.dueDate" [displayFormat]="dateFormat" stylingMode="filled" 
                                            placeholder="Select Date" [readOnly]="isReadOnly" [min] = "minDueDate">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Due Date is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-date-box>
                                </div>
                            </div>
                            <hr/>
                            <app-invoice-details-items [invoice]="creditRequest" [isReadOnly]="isReadOnly" [permissionType]="PermissionType.CreditRequestGlCodes" [negativeAmountsOnly]="true"/>
                        </div>
                    </div>
                    <app-notes 
                        [entityId]="number"
                        [noteType]="NoteType.CreditRequest"
                        [mode]="canViewNotes ? 'normal' : 'invisible'"
                        [canCreate]="canCreateNotes"
                        [canCreateInternal]="canCreateInternalNotes"
                        (noteSaved)="onNoteSaved()"
                        (noteCanceled)="onNoteCanceled()">
                    </app-notes>
                </div>
            }
        </dx-validation-group>
    </dx-scroll-view>
</div>
